'use strict';

class Dropdown {
  constructor(elem) {
    this.SPACEBAR_KEY_CODE = [0, 32];
    this.ENTER_KEY_CODE = 13;
    this.DOWN_ARROW_KEY_CODE = 40;
    this.UP_ARROW_KEY_CODE = 38;
    this.ESCAPE_KEY_CODE = 27;
    this.elem = elem;
    this.select = this.elem.querySelector('select');
    this.list = this.elem.querySelector('.js-dropdown-list');
    this.listItems = this.list.querySelectorAll(".js-dropdown-list-item");
    this.dropdownSelectedNode = this.elem.querySelector(".js-dropdown-selected");
    this.dropdownLabel = this.elem.querySelector(".js-dropdown-label");
    this.listItemIds = [];
    this.selectedLabel = this.elem.dataset.selectedLabel
    this.events();
  }

  events() {
    this.listItems.forEach(item => this.listItemIds.push(item.id));

    this.dropdownSelectedNode.addEventListener("click", e => {
      e.stopPropagation();
    });
  
    this.listItems.forEach(item => {
      item.addEventListener("click", e => {
        this.setSelectedListItem(item);
      });

      item.addEventListener("keydown", e => {
        switch (e.keyCode) {
          case this.ENTER_KEY_CODE:
            this.setSelectedListItem(item);
            return;

          case this.DOWN_ARROW_KEY_CODE:
            this.focusNextListItem(this.DOWN_ARROW_KEY_CODE);
            return;

          case this.UP_ARROW_KEY_CODE:
            this.focusNextListItem(this.UP_ARROW_KEY_CODE);
            return;

          default:
            return;
        }
      });
    });
  }

  setSelectedListItem(item) {
    this.dropdownLabel.innerHTML = item.innerHTML;
    // this.dropdownSelectedNode.insertAdjacentHTML('afterbegin', `${this.selectedLabel ? this.selectedLabel : ''}`);
    this.select.value = item.getAttribute('value');
    this.select.dispatchEvent(new Event('change'));
  }

  focusNextListItem(direction) {
    const activeElementId = document.activeElement.id;
   
    if (activeElementId === "js-dropdown-selected") {
      document.querySelector(`#${this.listItemIds[0]}`).focus();
    } else {
      const currentActiveElementIndex = this.listItemIds.indexOf(activeElementId);

      if (direction === this.DOWN_ARROW_KEY_CODE) {
        const currentActiveElementIsNotLastItem = currentActiveElementIndex < this.listItemIds.length - 1;
        if (currentActiveElementIsNotLastItem) {
          const nextListItemId = this.listItemIds[currentActiveElementIndex + 1];
          document.querySelector(`#${nextListItemId}`).focus();
        }
      } else if (direction === this.UP_ARROW_KEY_CODE) {
        const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
        if (currentActiveElementIsNotFirstItem) {
          const nextListItemId = this.listItemIds[currentActiveElementIndex - 1];
          document.querySelector(`#${nextListItemId}`).focus();
        }
      }
    }
  }
}

const dropdownElems = document.querySelectorAll('.js-dropdown');
for (let dropdownElem of dropdownElems) {
  dropdownElem.dropdown = new Dropdown(dropdownElem);
}
